import { Injectable } from '@angular/core';
import { BehaviorSubject, share, skipWhile } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: BehaviorSubject<any> = new BehaviorSubject(undefined);

  get config$() {
    return this.config.asObservable().pipe(
      skipWhile(config => config === undefined),
      share()
    );
  }

  notify(config: any) {
    if(config) {
      this.config.next(config);
    }
    else {
      this.config.next(undefined);
    }
  }
}
